import React, { useState, useEffect } from 'react';
import { Phone, Mail, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4">
        {/* Top bar */}
        <div className="hidden md:flex items-center justify-end py-2 text-sm border-b border-gray-100">
          <div className="flex items-center gap-6 text-gray-600">
            <a href="tel:0783518918" className="flex items-center gap-2 hover:text-blue-600 transition-colors">
              <Phone size={16} />
              <span>07 83 51 89 18</span>
            </a>
            <a href="mailto:cg.enrgies@gmail.com" className="flex items-center gap-2 hover:text-blue-600 transition-colors">
              <Mail size={16} />
              <span>cg.enrgies@gmail.com</span>
            </a>
          </div>
        </div>

        {/* Main navigation */}
        <div className="flex items-center justify-between py-4">
          {/* Logo */}
          <div className="flex items-center">
            <button onClick={() => scrollToSection('hero')} className="flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_comfort-systems-5/artifacts/2ev0qwwv_ChatGPT%20Image%2026%20f%C3%A9vr.%202026%2C%2016_32_30.png" 
                alt="CG Énergies" 
                className="h-24 w-auto"
              />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('hero')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Accueil
            </button>
            <button onClick={() => scrollToSection('services')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Services
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Contact
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button 
              onClick={() => window.location.href = 'tel:0783518918'}
              className="bg-gradient-to-r from-blue-600 to-teal-500 hover:from-blue-700 hover:to-teal-600 text-white px-6"
            >
              <Phone className="mr-2" size={18} />
              Nous Appeler
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-gray-700"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col gap-4">
              <button onClick={() => scrollToSection('hero')} className="text-left text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Accueil
              </button>
              <button onClick={() => scrollToSection('services')} className="text-left text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Services
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-left text-gray-700 hover:text-blue-600 transition-colors font-medium">
                Contact
              </button>
              <Button 
                onClick={() => window.location.href = 'tel:0783518918'}
                className="bg-gradient-to-r from-blue-600 to-teal-500 hover:from-blue-700 hover:to-teal-600 text-white w-full mt-2"
              >
                <Phone className="mr-2" size={18} />
                Nous Appeler
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
